import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { useAppSelector } from "../../../../util/hooks";
import { FormaPagamentoRecebimentoModel } from "../../../../models/formaPagamentoRecebimento/formaPagamentoRecebimentoModel";
import { SorteioModel } from "../../../../models/sorteio/sorteioModel";
import dayjs from "dayjs";
import { Flex, Skeleton } from "antd";

dayjs.locale("pt-br");

const VisualizarLancamentoBancario = (props: any) => {
  //estados globais
  const lancamentoBancarioState = useAppSelector((state) => state.lancamentoBancario);
  const formaPagamentoRecebimentoState = useAppSelector((state) => state.formaPagamentoRecebimento);
  const sorteioState = useAppSelector((state) => state.sorteio);

  return (
    <Flex vertical>
      {props.lancamento.tipoLancamento === "Transferência" ? (
        <>
          {lancamentoBancarioState.loadingDetalheTransferencia ? (
            <Skeleton active />
          ) : (
            <table>
              <tbody>
                <tr>
                  <td>Data: </td>
                  <td>{dayjs(lancamentoBancarioState.detalheTransferencia.data).format("DD/MM/YYYY")}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Empresa Origem: </td>
                  <td>{lancamentoBancarioState.detalheTransferencia.empresaOrigem}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Conta Banco Origem: </td>
                  <td>{lancamentoBancarioState.detalheTransferencia.contaBancoOrigem}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Empresa Destino: </td>
                  <td>{lancamentoBancarioState.detalheTransferencia.empresaDestino}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Conta Banco Destino: </td>
                  <td>{lancamentoBancarioState.detalheTransferencia.contaBancoDestino}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Forma de Pagamento: </td>
                  <td>
                    {formaPagamentoRecebimentoState.list.find((a: FormaPagamentoRecebimentoModel) => a.id === lancamentoBancarioState.detalheTransferencia.idFormaPagamentoRecebimento)?.denominacao}
                  </td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Sorteio: </td>
                  <td>{lancamentoBancarioState.detalheTransferencia.idSorteio ? dayjs(lancamentoBancarioState.detalheTransferencia.dataSorteio).format("DD/MM/YYYY") : "-"}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Valor: </td>
                  <td>{currencyBRL(lancamentoBancarioState.detalheTransferencia.valor)}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Histórico: </td>
                  <td>{lancamentoBancarioState.detalheTransferencia.historico || "-"}</td>
                </tr>
              </tbody>
            </table>
          )}
        </>
      ) : (
        <>
          {lancamentoBancarioState.loadingDetalheConta ? (
            <Skeleton active />
          ) : (
            <table>
              <tbody>
                <tr>
                  <td>Sorteio: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.dataSorteio ? dayjs(lancamentoBancarioState.detalheContaFinanceira.dataSorteio).format("DD/MM/YYYY") : "-"}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Empresa: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.empresa || "-"}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Conta Banco: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.contaBanco || "-"}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Plano Conta Financeiro: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.planoContaFinanceiro || "-"}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Cliente/Fornecedor: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.clienteFornecedor || "-"}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Tipo: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.tipo}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Valor: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.valor ? currencyBRL(lancamentoBancarioState.detalheContaFinanceira.valor) : currencyBRL(0)}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Data de Emissão: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.dataEmissao ? dayjs(lancamentoBancarioState.detalheContaFinanceira.dataEmissao).format("DD/MM/YYYY") : "-"}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Data de Vencimento: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.dataVencimento ? dayjs(lancamentoBancarioState.detalheContaFinanceira.dataVencimento).format("DD/MM/YYYY") : "-"}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Valor Líquido: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.valorLiquido ? currencyBRL(lancamentoBancarioState.detalheContaFinanceira.valorLiquido) : currencyBRL(0)}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Valor Pago: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.valorPago ? currencyBRL(lancamentoBancarioState.detalheContaFinanceira.valorPago) : currencyBRL(0)}</td>
                </tr>
                <tr>
                  <td> &nbsp;</td>
                </tr>
                <tr>
                  <td>Histórico: </td>
                  <td>{lancamentoBancarioState.detalheContaFinanceira.historico || "-"}</td>
                </tr>
              </tbody>
            </table>
          )}
        </>
      )}
    </Flex>
  );
};

export default VisualizarLancamentoBancario;
